import EntityService from '@/services/EntityService'
import { BudgetItem, budgetItemConverter } from '@/models/budget'
import StorageService from './StorageService'
import { fileTypeToString, getFileName } from '@/utils'

export default class BudgetTemplateService extends EntityService<BudgetItem> {
  constructor() {
    super({ collectionName: 'budgetItems', converter: budgetItemConverter })
  }

  public async create (data: BudgetItem): Promise<BudgetItem> {
    const budgetTemplate = {
      ...data,
      category: {
        name: '',
        weight: 0
      },
      status: null,
      dependsOn: '',
      assignedTo: '',
      startDate: null,
      endDate: null,
      attachments: [],
    } as BudgetItem

    let newBudgetItem = await super.create(budgetTemplate)

    // copy attachments to the new budget item
    if (data.attachments) {
      const storageService = new StorageService()
      const promises = data.attachments.map((attachment) => {
        let attachmentName = getFileName(attachment)
        attachmentName = attachmentName.indexOf('.') > -1 ? attachmentName.split('.')[0] : attachmentName
        const ext = fileTypeToString(attachment)
        const fileName = `${attachmentName}_${new Date().getTime()}.${ext}`
        return storageService.copyFile(attachment, `/budgets/${newBudgetItem.id}/${fileName}`)
      })
      let urls = []

      urls = await Promise.all(promises)
      newBudgetItem.attachments = urls
      newBudgetItem = await super.update(newBudgetItem.id, newBudgetItem)
    }

    return newBudgetItem
  }
}
